import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import {
  TransactionType,
  TransactionTypeFiltersResponse,
  TransactionTypeStatus,
} from 'dashboard/models/transaction-type';
import {
  setTransactionTypeFilterOptions,
  setTransactionTypes,
  TransactionTypesFilterParams,
} from 'dashboard/redux/actions/transaction-types';
import { ApiOptions } from 'lib/clients/ApiClient';
import { ApiEndpoint } from 'lib/interfaces/api';

export const loadTransactionTypesList = (
  arg: {
    filters?: TransactionTypesFilterParams;
    page?: ApiOptions['page'];
    abortSignal?: AbortSignal;
  } = {},
) => {
  const {
    filters: {
      omni = null,
      status = [TransactionTypeStatus.Active, TransactionTypeStatus.Inactive],
    } = {},
    page: { size = 100 } = {},
    abortSignal,
  } = arg;

  return async (dispatch: Dispatch) => {
    const { data: transactionTypes } = await SessionClientDashboard.listResource<TransactionType>(
      ApiEndpoint.TransactionType,
      {
        filter: { omni, status },
        page: { size },
        signal: abortSignal,
      },
    );
    dispatch(setTransactionTypes(transactionTypes));
  };
};

export const loadTransactionTypesFilterOptions = ({
  filters: { omni, status },
}: {
  filters: TransactionTypesFilterParams;
}) => {
  return async (dispatch: Dispatch) => {
    const { meta } = await SessionClientDashboard.get<TransactionTypeFiltersResponse>(
      ApiEndpoint.TransactionType,
      'basics',
      '',
      { filter: { omni, status } },
    );

    dispatch(setTransactionTypeFilterOptions(meta.filters));
  };
};
